// ACTIONS FOR PRODUCTS
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS'
export const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
// ACTIONS FOR USER
export const USER_LOGIN_AUTH = 'USER_LOGIN_AUTH'
export const CHECK_USER_INFOR = 'CHECK_USER_INFOR'
export const SET_ERR_LOGIN = 'SET_ERR_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const CART_ACTIONS = 'CART_ACTIONS'
export const SET_ORDER_USER = 'SET_ORDER_USER'
// ACTIONS FOR CATEGORIES
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES'
export const ADD_CATEGORIES = 'ADD_CATEGORIES'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
// ACTIONS FOR ORDERS
export const GET_ORDERS_USER = 'GET_ORDERS_USER'
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS'
export const DELETE_ORDER = 'DELETE_ORDER'
export const UPDATE_STATUS_ORDER = 'UPDATE_STATUS_ORDER'
